<template>
<div class="rule_box" v-if="show">
  <div class="rule_close" @click="$emit('update:show', false)"></div>  
  一、参与用户需年满18周岁，具备完全民事行为能力； <br><br>
  二、此次活动的参与用户必须与实际购车人一致，因北京地区限购政策等原因导致参与用户无法完成购车的，由参与用户自行负责；<br><br>
  三、活动期间，因参与用户操作不当或参与人所在区域网络故障、支付平台网络不畅、电信运营商故障等非电动邦所能控制的原因导致的参与用户无法参与活动或参与失败，电动邦不予负责； <br><br>
  四、电动邦依法运营此次活动，如遇不可抗力因素（不可抗力是指不能控制、不可预见或不能避免，即使预见亦无法避免的事件，该事件使任何一方根据本协议履行其全部或部分义务已不可能）导致本次活动无法进行时或需要暂停举办的，包括（活动受政府机关指令要求停办，活动遭受严重网络攻击出现宕机或系统故障需要暂停举办的），在法律允许的范围内，电动邦有权决定取消、终止、修改或暂停本活动，电动邦无需为此承担赔偿或进行任何形式的补偿； <br><br>
  五、电动邦可以根据本活动的实际举办情况对活动规则进行变动或调整，并公布在活动页面及电动邦官网（www.diandong.com）上； <br><br>
  六、电动邦仅作为提供汽车优惠信息、优惠政策的平台，不对经销商的产品品质提供任何担保；<br><br>
  七、用户应按中国法律规定，自行完成购车并与经销商沟通办理车辆保险等事宜，期间产生的任何税费均由用户个人自行承担； <br><br>
  八、用户在线下与经销商因购车，含异地购车、车辆置换、售后服务等相关事宜而产生的纠纷，应由双方按照法律规定或购车合同约定解决，电动邦不参与解决此类纠纷，也不承担对应责任； <br><br>
  九、任何人或任何网站以电动邦名义从事此类似活动或恶意通知用户领奖，造成用户损失的，由用户自己承担，与电动邦无关； <br><br>
  十、对于活动的规则及最终执行，电动邦保留最终解释权；<br><br>
  十一、活动期间所有参与秒杀的车型，仅限北京地区拥有新能源指标的用户可以享受相关权益，非北京地区或暂无新能源指标的用户，将不能享受本次秒杀的所有权益；<br><br>
  <br>
  疑问垂询<br>
  如有与活动相关的任何疑问，您可以通过以下形式联系电动邦，我们会及时提供反馈。<br>
  电子邮箱：bangjijin@diandong.com<br>
</div> 
</template>
<script>
  export default {
    name: "Rule",
    props: {
      show: Boolean
    },
    data() {
      return {
        rule_show:false
      };
    },
    methods:{
    }
  }
</script>
<style scoped>
.rule_box{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 90px 50px;
  white-space:pre-line;
  font-size: 24px;
  line-height: 31px;
  text-align: left;
  color: #010101;
  background: #fff;
}
.rule_tit{
  font-size: 26px;
  font-weight: bold;
}
.rule_close{
  width: 120px;
  height: 120px;
  position: fixed;
  right: 0;
  top: 0;
  background: url(../../assets/images/brandWeek/close_pink.png) no-repeat center center;
  background-size: 80px 80px;
}
</style>